import { FC } from 'react';
import classNames from 'classnames';
import {
  CheckmarkFilled,
  CircleDash,
  InProgress,
  Misuse,
  WarningAltFilled,
} from '@carbon/react/icons';
import { FloatingTooltip } from 'components/floating-tooltip';
import type { WorkflowStatus, ValidationStatus } from './types';
import styles from './page.module.scss';

export const WorkflowStatusCell: FC<{
  status: WorkflowStatus;
  failureReason?: string | null;
}> = ({ status, failureReason }) => {
  switch (status) {
    case 'complete':
      return (
        <span className={classNames(styles.statusBadge, styles.statusComplete)}>
          <CheckmarkFilled />
          Completed
        </span>
      );
    case 'in_progress':
      return (
        <span
          className={classNames(styles.statusBadge, styles.statusInProgress)}
        >
          <InProgress />
          Running
        </span>
      );
    case 'failed': {
      const badge = (
        <span className={classNames(styles.statusBadge, styles.statusFailed)}>
          <Misuse />
          Failed
        </span>
      );
      return failureReason ? (
        <FloatingTooltip content={failureReason} placement="top">
          {badge}
        </FloatingTooltip>
      ) : (
        badge
      );
    }
    default:
      return (
        <span
          className={classNames(styles.statusBadge, styles.statusNotStarted)}
        >
          <CircleDash />
          Pending
        </span>
      );
  }
};

export const ValidationStatusCell: FC<{ status: ValidationStatus }> = ({
  status,
}) => {
  switch (status) {
    case 'valid':
      return (
        <span className={classNames(styles.statusBadge, styles.valValid)}>
          <CheckmarkFilled />
          Valid
        </span>
      );
    case 'processing':
      return (
        <span className={classNames(styles.statusBadge, styles.valProcessing)}>
          <InProgress />
          Processing
        </span>
      );
    case 'warning':
      return (
        <span className={classNames(styles.statusBadge, styles.valWarning)}>
          <WarningAltFilled />
          Warning
        </span>
      );
    case 'error':
      return (
        <span className={classNames(styles.statusBadge, styles.valError)}>
          <Misuse />
          Error
        </span>
      );
    default:
      return (
        <span className={classNames(styles.statusBadge, styles.valNotStarted)}>
          <CircleDash />
          Not Started
        </span>
      );
  }
};

export const SpacingStatusCell: FC<{ status: string }> = ({ status }) => {
  switch (status) {
    case 'complete':
      return (
        <span className={classNames(styles.statusBadge, styles.statusComplete)}>
          <CheckmarkFilled />
          Completed
        </span>
      );
    case 'in_progress':
      return (
        <span
          className={classNames(styles.statusBadge, styles.statusInProgress)}
        >
          <InProgress />
          Running
        </span>
      );
    case 'failed':
      return (
        <span className={classNames(styles.statusBadge, styles.statusFailed)}>
          <Misuse />
          Failed
        </span>
      );
    default:
      return (
        <span
          className={classNames(styles.statusBadge, styles.statusNotStarted)}
        >
          <CircleDash />
          Pending
        </span>
      );
  }
};
